<div class="template-detail-container">
  <nz-spin *ngIf="loading && !error" [nzSpinning]="true" [nzTip]="'builderScreen.templateDetail.loading' | translateTA">
    <div style="min-height: 200px;"></div>
  </nz-spin>

  <nz-result
    *ngIf="error"
    nzStatus="error"
    [nzTitle]="'builderScreen.templateDetail.loadErrorTitle' | translateTA"
    [nzSubTitle]="errorMessage">
  </nz-result>

  <tem-screen-view [templateId]="templateId" [data]="context"></tem-screen-view>
</div>
